import { ProfilePage } from './components/ProfilePage';
import { useQuery } from '@apollo/client';
import { GET_OWNER } from '~/services/auth';

const Profile = ({}) => {
  const { data } = useQuery(GET_OWNER);
  const ownerData = data?.response?.data || {}; // operador de cadena, porque depronto una parte de la cadena es undefined

  return (
    <div className="mx-auto h-fit w-full max-w-[1200px] px-0 pt-12 md:px-8">
      <ProfilePage
        email={ownerData.email}
        firstName={ownerData.first_name}
        lastName={ownerData.last_name}
        phoneNumber={ownerData.primary_phone_number}
      />
    </div>
  );
};

export default Profile;
